import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, FeaturesConfigModule, I18nModule, provideDefaultConfig } from '@spartacus/core';
import { CustomProductSummaryComponent } from './product-summary.component';
import { OutletModule } from '@spartacus/storefront';
import { CustomPromotionsModule } from '../../store-front/misc/cms-components/promotions';
import { RouterModule } from '@angular/router';
import { ProductReplacementComponent } from '../product-replacement/product-replacement.component';

@NgModule({
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        ProductSummaryComponent: {
          component: CustomProductSummaryComponent,
        },
      },
    }),
  ],
  declarations: [CustomProductSummaryComponent],
  exports: [CustomProductSummaryComponent],
  imports: [
    CommonModule,
    OutletModule,
    I18nModule,
    CustomPromotionsModule,
    FeaturesConfigModule,
    RouterModule,
    ProductReplacementComponent,
  ],
})
export class CustomProductSummaryModule {}
